// These are all exact routes, so be sure to keep that in mind when adding any new items.
export const controlCenterRoutes = [
   '/critical_communications',
   '/risk_intelligence',
   '/incident_management',
   '/configure/shapes-library'
]